import React from 'react';
import { usePermissions, useUserMany } from '@lumahealthhq/ui-model';
import { ERollout } from '@lumahealthhq/ui-model-types';
var useNavigatorData = function useNavigatorData() {
  var _usePermissions = usePermissions(),
    hasAccessToProduct = _usePermissions.hasAccessToProduct;
  var hasAccessToSparkNavigator = hasAccessToProduct(ERollout.SparkNavigator);
  // TODO: @rrubenich - add to Spark Navigator ERollout
  var hasAccessToSparkStaffExperience = hasAccessToProduct('spark-staff-experience');
  var data = useUserMany({
    roles: 'assistant'
  }, {
    enabled: hasAccessToSparkNavigator
  });
  var navigatorUsersIds = React.useMemo(function () {
    var _data$data;
    return ((_data$data = data.data) == null ? void 0 : _data$data.map(function (_ref) {
      var _id = _ref._id;
      return _id;
    })) || [];
  }, [data]);
  return {
    data: data,
    navigatorUsersIds: navigatorUsersIds,
    permissions: {
      hasAccessToSparkNavigator: hasAccessToSparkNavigator,
      hasAccessToSparkStaffExperience: hasAccessToSparkStaffExperience
    }
  };
};
export default useNavigatorData;